/* eslint-disable no-useless-escape */
export const loosePhoneRegexp = /^[\+0-9\s\-\(\)]+$/;
